import React from 'react';
import { quotesPropType } from '../../utils/propTypes';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import QuotesDetailsBox from './QuotesDetailsBox';

const QuotesCompactList = ({ quotes }) => {
  const { maxListSize } = useQuoteContext();

  return (
    <div className="sui-flex sui-flex-col sui-gap-3 sui-mb-8" data-testid="QuotesCompactList">
      {quotes?.slice(0, maxListSize).map((quote, index) => (
        <QuotesDetailsBox
          key={`${quote.cartId}-${index}`}
          quote={quote}
          fullWidth
          index={index}
        />
      ))}
    </div>
  );
};

QuotesCompactList.propTypes = {
  quotes: quotesPropType
};

QuotesCompactList.defaultProps = {
  quotes: []
};

export default QuotesCompactList;
